import ReactPixel from 'react-facebook-pixel';
import { getStorageTracking } from '../storage/StorageTracking';

export async function getVstId(userregistrationtracking) {
  try {
    const storageTracking = getStorageTracking();

    const { vst_id: vstId } = storageTracking;

    if (userregistrationtracking && userregistrationtracking.data) {
      const { vst_id } = userregistrationtracking.data.trackings;

      if (!vst_id) {
        return null;
      }

      return userregistrationtracking.data.trackings.vst_id;
    }

    if (!vstId || vstId === '') {
      return null;
    }

    return vstId;
  } catch (err) {
    // console.log('Erro ao verificar fbc', err)
  }
}

let isMetaPixelInitialized = false;
let isTikTokPixelInitialized = false;

export async function initializePixels() {
  if (typeof window === 'undefined') return;

  // Meta Pixel - Init apenas 1x
  if (!isMetaPixelInitialized) {
    ReactPixel.init('1775048205980627');
    isMetaPixelInitialized = true;
    // console.log('✅ Meta Pixel inicializado');
  }

  // TikTok Pixel - Load apenas 1x
  if (typeof window.ttq?.load === 'function' && !isTikTokPixelInitialized) {
    window.ttq.load('CV4BBM3C77UC4ANDSNP0');
    isTikTokPixelInitialized = true;
    // console.log('✅ TikTok Pixel inicializado');
  }
}
